import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import markedImg from '../../../assets/marked-product.svg'
import { gotoLogIn } from '../../../redux/actions/AuthActions'
import { logEvent } from '../../../utils/firebase'
import { formatter } from '../../../utils/normalizedata'
import { SaveProductIcon } from '../SaveProductIcon'
import LockIcon from '../../../assets/lock.svg'

const Container = styled.div`
  width: 194px;
  height: 220px;
  background: #ffffff;
  border-radius: 10px;
  position: relative;
  padding: 10px 10px;
  transition: all 0.5s ease;
  animation: appear 0.25s;
  animation-fill-mode: forwards;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  justify-content: space-between;
  font-size: 14px;
  overflow: hidden;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 42vw;
    height: 200px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
  }
`

const InfoContainer = styled.div`
  text-align: center;
  width: 90%;
`

const Title = styled.div`
  font-weight: 500;
  white-space: nowrap;
  margin-bottom: 8px;
  overflow: hidden;

  @media (max-width: 600px) {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.01em;
  }
`

const Price = styled.div`
  font-weight: 700;

  @media (max-width: 600px) {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
  }
`

const ThumbContainer = styled.div`
  padding-top: 40px;
  width: 110px;
  height: 110px;

  @media (max-width: 600px) {
    padding-top: 0;
  }
`

const ThumbImage = styled.img`
  object-fit: contain;
`

const StoreNameContainer = styled.div`
  position: absolute;
  top: 5px;
  left: 12px;

  @media (max-width: 600px) {
    top: 4px;
    left: 4px;
    font-size: 10px;
  }
`

const StoreImageContainer = styled.div`
  position: absolute;
  top: 5px;
  left: 12px;
`

const StoreImage = styled.img`
  object-fit: contain;
  max-height: 20px;
  width: auto;
  max-width: 70px;
  object-fit: contain;
`

const MarkedProductImg = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
`

const MyDecorOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
`

const storeDataMap = (stores, id, name) => {
  if (stores[id])
    return (
      <StoreImageContainer>
        <StoreImage src={stores[id].imageName} alt={name} />
      </StoreImageContainer>
    )

  return <StoreNameContainer>{name}</StoreNameContainer>
}

const cap = (string = '') => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const ProductCard = ({ data, name, index, savedProductIds, allSavedProducts, marked, handleShowMyDecor }) => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
  const { brandsByKeys } = useSelector(state => state.brand)

  const dispatch = useDispatch()
  //var url = data.imgUrl || data.imgurl || 'https://' + data.baseUrl + '/' + data.thumbImageFileLoc + data.thumbImageFileName
  let url = data.imgUrl || data.imageUrl
  if (!url && data.baseUrl) url = 'https://' + data.baseUrl + '/' + data.thumbImageFileLoc + data.thumbImageFileName
  const handleToProduct = () => {
    if (!isAuthenticated) {
      dispatch(gotoLogIn())
      return
    }

    if (!data.productUrl) return
    logEvent('select_content', {
      content_type: name ? name : 'product',
      content_id: data.objectId,
      items: [
        {
          name: data.title,
          brand: data.storeId
        }
      ]
    })

    const tag = 'design_' + name + '_clicked'
    logEvent(tag)

    window.open(data.productUrl, '_blank')
  }

  return (
    <Container>
      <div>
        {storeDataMap(brandsByKeys, data.storeId, data.storeName)}
        {data.title !== 'MyDecor' && <SaveProductIcon savedProductIds={savedProductIds} id={data.objectId} saveObjectId={allSavedProducts[data.objectId]} type="Item" />}
      </div>
      <ThumbContainer onClick={handleToProduct} rel="noopener noreferrer">
        <ThumbImage
          loading="lazy"
          alt={data.title ? data.title : 'Decormatters'}
          src={url}
          //onError={e => (e.target.src = '/onerror.png')}
          width="100%"
          height="100%"
        />
      </ThumbContainer>
      <InfoContainer>
        <Title>{data.title ? cap(data.title) : 'MyDecor'}</Title>
        {data.salePrice && data.salePrice > 0 && <Price>{formatter.format(data.salePrice)}</Price>}
      </InfoContainer>
      {marked && <MarkedProductImg src={markedImg} alt="Selected Item" />}
      {(!data.type || data.type === 'u') && (
        <MyDecorOverlay onClick={handleShowMyDecor}>
          <img src={LockIcon} alt="Item Locked" />
        </MyDecorOverlay>
      )}
    </Container>
  )
}

export default ProductCard
